import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["amount", "previewAmount", "total"]
  static values = { currency: String }

  recalculate() {
    let grandTotal = 0

    this.amountTargets.forEach((input) => {
      const value = parseFloat(input.value) || 0
      const invoiceId = input.dataset.invoiceId
      grandTotal += value

      this.updatePreviewAmounts(invoiceId, value)
    })

    this.totalTarget.textContent = this.formatCurrency(grandTotal)
  }

  updatePreviewAmounts(invoiceId, value) {
    this.previewAmountTargets.forEach((el) => {
      if (el.dataset.invoiceId === invoiceId) {
        el.textContent = this.formatCurrency(value)
      }
    })
  }

  formatCurrency(amount) {
    return this.currencyValue + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}
